import * as Stimulus from "@hotwired/stimulus"

export class InputController extends Stimulus.Controller {

    formatDateString(dateString) {
        let dsec = Date.parse(dateString);
        let d = new Date(dsec).toLocaleDateString('en-us',
            { year: "numeric"
            , month: "long"
            , day: "numeric"
            , timeZone: "UTC" // Timezone must be UTC to always match the raw dateString
            }
        );
        return d;
    }

    makeInputLabel($input) {
        let label = null;
        if($input.labels.length > 0) {
            label = $input.labels[0].innerText;
        }
        return label;
    }

    customErrorRenderer = {
        date: {
            rangeUnderflow: ($input) => {
                return `${$input.placeholder || $input.title || 'Date'} must be on or after ${this.formatDateString($input.min)}.`
            },
            rangeOverflow: ($input) => {
                return `${$input.placeholder || $input.title || 'Date'} must be on or before ${this.formatDateString($input.max)}.`
            }
        },
        number: {
            rangeUnderflow: ($input) => {
                const label = this.makeInputLabel($input)
                                || $input.placeholder
                                || 'Value';
                return `${label} must be greater than or equal to ${$input.min}.`
            },
            rangeOverflow: ($input) => {
                const label = this.makeInputLabel($input)
                                || $input.placeholder
                                || 'Value';
                return `${label} must be less than or equal to ${$input.max}.`
            },
        }
    }

    validationErrors = [
        'badInput',
        'patternMismatch',
        'rangeOverflow',
        'rangeUnderflow',
        'stepMismatch',
        'tooLong',
        'tooShort',
        'typeMismatch',
        'valid',
        'valueMissing',
    ];

    validateDebounceTimer = null;

    validateDebounce(e) {
        clearTimeout(this.validateDebounceTimer);
        this.validateDebounceTimer = setTimeout(() => {
            this.validate(e)
            this.validateDebounceTimer = null;
        }, 1200);
    }

    validate(e) {
        if(!this.element.checkValidity()) {
            e.stopPropagation();
            e.preventDefault();
            this.dispatch("invalid", { prefix: "form", bubbles: true, detail: { errorMessage: this.validationMessage() }});
        }
    }

    validationMessage() {
        let $input = this.element
        for(let e of this.validationErrors) {
            if($input.validity[e]
                && $input.dataset[`error:${e}`]) {
                return $input.dataset[`error:${e}`];
            } else if($input.validity[e]
                && this.customErrorRenderer.hasOwnProperty($input.type)
                && this.customErrorRenderer[$input.type].hasOwnProperty(e)
            ) {
                return this.customErrorRenderer[$input.type][e]($input)
            }
        }
        return $input.validationMessage;
    }
}
